import React from 'react'
import PropTypes from 'prop-types'
import styles from './Pagination.scss'
import { Row, Col, Pagination as PaginationLib, PaginationItem, PaginationLink } from 'reactstrap'

const Pagination = props =>
  <Row className={styles.Pagination}>
    <Col sm={{ size: 6, offset: 3 }} style={{width: '100%', textAlign: 'center'}}>
      <div style={{display: 'inline-block'}}>
        <PaginationLib>
          <PaginationItem>
            <PaginationLink className={styles.PaginationLink} previous onClick={() => { props.prevPage() }} />
          </PaginationItem>

          {props.pages && props.pages.map((label, i) =>
            <PaginationItem key={i} active={props.currentPage === (i + 1)}>
              <PaginationLink className={styles.PaginationLink} onClick={() => props.changePage(i + 1)}>
                {label}
              </PaginationLink>
            </PaginationItem>
          )}

          <PaginationItem>
            <PaginationLink className={styles.PaginationLink} next onClick={() => { props.nextPage() }} />
          </PaginationItem>
        </PaginationLib>
      </div>
    </Col>
  </Row>

Pagination.propTypes = {
  prevPage: PropTypes.func,
  nextPage: PropTypes.func,
  pages: PropTypes.array,
  currentPage: PropTypes.number
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js